module.exports = __webpack_public_path__ + "img/bg_disabled@2x.140cae2.png";